
import { INVOICE_DETAILED_PAGE_VISITED } from "@/constants/MixpanelEvents.js";
import backButtonOutlined from "../../components/common/back-button-outlined.vue";
import InvoicesTableView from "../../components/invoices/invoices-table-view.vue";
import TransactionHistory from "../../components/invoices/transaction-history.vue";

export default {
  components: {
    backButtonOutlined,
    InvoicesTableView,
    TransactionHistory
  },
  data() {
    return {
      search: ""
    };
  },
  mounted() {
    this.mixPanelTrackEvent(INVOICE_DETAILED_PAGE_VISITED);
  }
};
